// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportObjects = {
	"./node_modules/@configura/internal/web_core_internal_bg.wasm": function() {
		return {
			"./web_core_internal_bg.js": {
				"__wbg_new_03a50b2d1045a68f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c["./node_modules/@configura/internal/web_core_internal_bg.js"].exports;
					return wasmImportedFuncCache0["__wbg_new_03a50b2d1045a68f"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c["./node_modules/@configura/internal/web_core_internal_bg.js"].exports;
					return wasmImportedFuncCache1["__wbindgen_throw"](p0i32,p1i32);
				},
				"__wbindgen_rethrow": function(p0i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c["./node_modules/@configura/internal/web_core_internal_bg.js"].exports;
					return wasmImportedFuncCache2["__wbindgen_rethrow"](p0i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"vendors-node_modules_mui_icons-material_Description_js-node_modules_mui_icons-material_Downlo-cf8d6c": [
		"./node_modules/@configura/internal/web_core_internal_bg.wasm"
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"vendors-node_modules_mui_icons-material_Description_js-node_modules_mui_icons-material_Downlo-cf8d6c":{"./node_modules/@configura/internal/web_core_internal_bg.wasm":"a3a77e24f340081b2d42"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};